import type { FC } from 'react';
import { PapiDeviation, PapiGallection } from '@wix/da-papi-types';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import { StudioSection } from '../../../types/store';
import { GALLERY_SUBFOLDERS_STREAM } from '../../../../constants';
import StudioTableDesktop from '../../StudioTableDesktop';
import { FolderListDesktop } from '../FolderList';
import { TierListDesktop } from '../TierList';
import PublishedFolderHeaderDesktop from '../FolderHeaderDesktop';
import PublishedBlankSlate from '../../StudioBlankSlate/sections/PublishedBlankSlate';
import PostsBlankSlate from '../../StudioBlankSlate/sections/PostsBlankSlate';
import TierBlankSlate from '../../StudioBlankSlate/sections/TierBlankSlate';
import { useCanCreateSubfolder } from '../../../hooks/useCanCreateSubfolder';

export interface Props {
  activeSection: StudioSection;
  selectedFolder?: PapiGallection;
  subfolders?: PapiGallection[];
  tiers?: PapiDeviation[];
  contentType?: string;
  tierId?: string;
  hasDeviations?: boolean;
  isRootFolder?: boolean;
}

const PublishedPageContent: FC<Props> = ({
  activeSection,
  selectedFolder,
  hasDeviations,
  isRootFolder,
  tiers,
  contentType,
  tierId,
}) => {
  const canCreateFolders = useCanCreateSubfolder(selectedFolder);
  const isMyGalleriesPage = activeSection === StudioSection.PUBLISHED_GALLERIES;
  const isMyTiersPage = activeSection === StudioSection.PUBLISHED_TIERS;
  return (
    <>
      {!isRootFolder && <PublishedFolderHeaderDesktop />}
      {!isMyGalleriesPage && !isMyTiersPage && hasDeviations && <StudioTableDesktop />}
      {!isMyGalleriesPage && !isMyTiersPage && !hasDeviations && (
        <>
          {contentType === 'posts' && <PostsBlankSlate />}
          {contentType !== 'posts' && tierId && <TierBlankSlate />}
          {contentType !== 'posts' && !tierId && <PublishedBlankSlate />}
        </>
      )}
      {isMyTiersPage && tiers && tiers.length > 0 && (
        <TierListDesktop
          tiers={tiers}
          measuredCookieType={MeasuredCookieType.STUDIO_SUBFOLDER_CARD}
        />
      )}
      {isMyTiersPage && (!tiers || tiers.length === 0) && <TierBlankSlate />}
      {isMyGalleriesPage && tiers && tiers.length > 0 && (
        <TierListDesktop
          tiers={tiers}
          measuredCookieType={MeasuredCookieType.STUDIO_SUBFOLDER_CARD}
        />
      )}
      {isMyGalleriesPage && (
        <FolderListDesktop
          streamId={GALLERY_SUBFOLDERS_STREAM.streamId}
          selectedFolder={selectedFolder as PapiGallection}
          measuredCookieType={MeasuredCookieType.STUDIO_SUBFOLDER_CARD}
          expandedByDefault={true}
          withCreateButton={canCreateFolders}
          withFolderActions={true}
          withDragToOrder={true}
          withCollapseToggle={false}
          withHeader
        />
      )}
    </>
  );
};
PublishedPageContent.displayName = 'PublishedPageContent';

export default PublishedPageContent;
